import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { ButtonReturn } from '../../../components/common/ButtonReturn';
import { voicesTypeControl } from '../../../types/audioType';
import { sub2_act4_01, sub2_act4_02, sub2_act4_03, sub2_act4_04, sub2_act4_05 } from '../../../assets/tema8';
import { ModalInfoTextV3 } from '../../../components/common/ModalInfoTextV3';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	win: 8
};

export const Theme8SubtopicTwoActivityFour = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema8.activities.subtema2], 4);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 8 sub 2 act 4");
			ObserverEmitter.emit(EVENTS.tema8.topic2.initScene, 4);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema2.actividad4.sub2a4a01)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema8.topic2.initScene, 4);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name='Actividad 4: Medidas preventivas.' />
					<DialogBarNew
						dialog={`Te compartimos las siguientes medidas preventivas en punto de venta:`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2. Situaciones de riesgo"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<ModalInfoTextV3
						title='ANTES'
						url={sub2_act4_01}
						callback={() => {
							setUiToShow(steps.dialogThree);
						}}
					>
						<div>
							<p className="text-[12px] md:text-[16px]">
								Mantenerse siempre alerta:
							</p>
							<ul className="pl-4">
								<li className="list-disc font-normal text-[12px] md:text-[16px] text-black">
									Saludar y hacer contacto visual.
								</li>
								<li className="list-disc font-normal text-[12px] md:text-[16px] text-black">
									No dar la espalda al piso de venta cuando se encuentre un cliente.
								</li>
								<li className="list-disc font-normal text-[12px] md:text-[16px] text-black">
									Si una persona ha estado mucho tiempo, pregúntale “¿Le puedo ayudar en algo?”.
								</li>
							</ul>
						</div>
					</ ModalInfoTextV3 >
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<ModalInfoTextV3
						title='ANTES'
						url={sub2_act4_02}
						callback={() => {
							setUiToShow(steps.dialogFour);
						}}
					>
						<div>
							<p className="text-[12px] md:text-[16px]">
								Poner atención y evitar confrontar, cuando se observe clientes con:
							</p>
							<ul className="pl-4">
								<li className="list-disc font-normal text-[12px] md:text-[16px] text-black">
									Mochila y bolsas de mano grande
								</li>
								<li className="list-disc font-normal text-[12px] md:text-[16px] text-black">
									Carriolas para el traslado de bebés
								</li>
								<li className="list-disc font-normal text-[12px] md:text-[16px] text-black">
									Ropa fuera de temporada
								</li>

							</ul>
						</div>
					</ ModalInfoTextV3 >
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<ModalInfoTextV3
						title='DURANTE'
						description='Si se detecta a la persona guardando o escondiendo mercancía entre sus pertenencias, indicarle amablemente donde puede pagar el producto: “En caja le podemos cobrar sus productos”'
						url={sub2_act4_03}
						callback={() => {
							setUiToShow(steps.dialogFive);
						}}
					>
					</ ModalInfoTextV3 >
				</>
			)}

			{uiToShow === steps.dialogFive && (
				<>
					<ModalInfoTextV3
						title='DURANTE'
						url={sub2_act4_04}
						callback={() => {
							setUiToShow(steps.dialogSix);
						}}
					>
						<div>
							<p className="text-[12px] md:text-[16px]">
								Mantener la calma.
							</p>
							<ul className="pl-4">
								<li className="list-disc font-normal text-[12px] md:text-[16px] text-black">
									Tratar de observar características físicas y detalles que puedan ayudar a la identificación de los mismos.
								</li>
								<li className="list-disc font-normal text-[12px] md:text-[16px] text-black">
									No tratar de seguir ni detener al o los sujetos.
								</li>

							</ul>
						</div>
					</ ModalInfoTextV3 >
				</>
			)
			}

			{
				uiToShow === steps.dialogSix && (
					<>
						<ModalInfoTextV3
							title='DESPUES'
							url={sub2_act4_05}
							callback={() => {
								setUiToShow(steps.win);
							}}
						>
							<div>
								<ul className="pl-4">
									<li className="list-disc font-normal text-[12px] md:text-[16px] text-black">
										Reporta al Centro de Control.
									</li>
									<li className="list-disc font-normal text-[12px] md:text-[16px] text-black">
										Marca 7911 directo desde tienda o al número que se encuentra al reverso de tu gafete.
									</li>

								</ul>
							</div>
						</ModalInfoTextV3>
					</>
				)
			}

			{
				uiToShow === steps.win && (
					<>
						<ValidationResultModal
							title="¡Bien hecho!"
							dialogModal="Ahora conoces sobre medidas preventivas en punto de venta, asegurando tu seguridad en cualquier circunstancia."
							buttonTxt="Continuar"
							isCorrect={true}
							action={() => {
								dispatch(
									completeOneTask({
										idActivity: 4,
										pointsWin: 0,
										subtema: tasksId.tema8.activities.subtema2
									})
								);
								navigator("/home8/tema8/subtema2/activityFive");
							}}
						/>
					</>
				)
			}
		</>
	)
}
